import React, { useEffect, useRef, useState } from "react";
import { SpeakerHigh, Pause, Play, Stop } from "@phosphor-icons/react";

/** Read-aloud mode for text lessons using the browser's built-in speech synthesis. */
export const ReadAloudButton = ({ text }) => {
  const [state, setState] = useState("idle"); // idle | playing | paused
  const utterRef = useRef(null);

  useEffect(() => () => window.speechSynthesis?.cancel(), []);
  useEffect(() => { window.speechSynthesis?.cancel(); setState("idle"); }, [text]);

  if (!("speechSynthesis" in window) || !text?.trim()) return null;

  const start = () => {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.95;
    u.onend = () => setState("idle");
    u.onerror = () => setState("idle");
    utterRef.current = u;
    window.speechSynthesis.speak(u);
    setState("playing");
  };
  const pause = () => { window.speechSynthesis.pause(); setState("paused"); };
  const resume = () => { window.speechSynthesis.resume(); setState("playing"); };
  const stop = () => { window.speechSynthesis.cancel(); setState("idle"); };

  return (
    <div className="flex items-center gap-1.5" data-testid="read-aloud-controls">
      {state === "idle" && (
        <button data-testid="read-aloud-play" onClick={start}
          className="btn-ghost text-xs font-semibold flex items-center gap-1.5 border border-[#C4C8CE] rounded-full px-3 py-1.5 bg-white hover:border-[#CCFF00]">
          <SpeakerHigh size={14} weight="duotone" /> Read this lesson aloud
        </button>
      )}
      {state === "playing" && (
        <>
          <button data-testid="read-aloud-pause" onClick={pause}
            className="btn-ghost text-xs font-semibold flex items-center gap-1 border border-[#C4C8CE] rounded-full px-3 py-1.5 bg-[#CCFF00]">
            <Pause size={13} weight="fill" /> Pause
          </button>
          <button data-testid="read-aloud-stop" onClick={stop}
            className="btn-ghost text-xs flex items-center gap-1 border border-[#C4C8CE] rounded-full px-3 py-1.5 bg-white">
            <Stop size={13} weight="fill" /> Stop
          </button>
        </>
      )}
      {state === "paused" && (
        <>
          <button data-testid="read-aloud-resume" onClick={resume}
            className="btn-ghost text-xs font-semibold flex items-center gap-1 border border-[#C4C8CE] rounded-full px-3 py-1.5 bg-white hover:border-[#CCFF00]">
            <Play size={13} weight="fill" /> Resume
          </button>
          <button data-testid="read-aloud-stop" onClick={stop}
            className="btn-ghost text-xs flex items-center gap-1 border border-[#C4C8CE] rounded-full px-3 py-1.5 bg-white">
            <Stop size={13} weight="fill" /> Stop
          </button>
        </>
      )}
    </div>
  );
};
